import type { InstallableRegistry } from '@cli-types/core-engine/installable.js'

export function createRegistry<TDefinition, TId extends string>(
  registry: Record<string, TDefinition>,
  noun: string
): InstallableRegistry<TDefinition, TId> {
  function formatUnknownMessage(ids: string[]): string {
    return `Unknown ${noun}(s): ${ids.join(', ')}. Available for next: ${Object.keys(registry).join(', ')}`
  }

  return {
    list() {
      return Object.values(registry)
    },
    get(id) {
      const definition = registry[id]
      if (!definition) {
        throw new Error(formatUnknownMessage([id]))
      }
      return definition
    },
    is(value): value is TId {
      return value in registry
    },
    formatUnknownMessage
  }
}
